/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from 'react';
import Cookie from 'js-cookie';
import { toast } from 'react-toastify';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { v4 as generateUuid } from 'uuid';
import { apiCall } from 'api/apiCall';
import { API_STATUS } from 'api/status';
import queryString from 'query-string';

const SurveyExternalSource = () => {
  const { surveyUuid } = useParams();
  const location = useLocation();
  const { search } = location;
  const history = useHistory();
  const {
    sample,
    a: cintUserId,
  }: { a?: string; sample?: any } = queryString.parse(search);

  const isProduction = process.env.NODE_ENV === 'production';

  const getSurveKey = (userUuid: string) => {
    const url = sample
      ? `keys/public-keys/${surveyUuid}/get-key/?userID=${userUuid}&sample=${sample}`
      : `keys/public-keys/${surveyUuid}/get-key/?userID=${userUuid}`;
    return apiCall(url, 'POST')
      .then(({ data }: any) => {
        history.push(`/${data.uuid}${search}`);
      })
      .catch((err: any) => {
        const { status } = err.response;

        if (err && err.response.status === 404) {
          if (err.response.data.status === 'finished') {
            history.push('/finished');
          }
        } else {
          toast.error(API_STATUS[status]);

          history.push('/');
        }
      });
  };

  useEffect(() => {
    const cookie = Cookie.get(`key_${surveyUuid}`);

    if (cookie) {
      getSurveKey(cookie);
    } else {
      const uuid = cintUserId || generateUuid();

      Cookie.set(`key_${surveyUuid}`, uuid, {
        expires: 7,
        path: '/',
        domain: isProduction ? '.deeptrue.com' : 'localhost',
      });
      getSurveKey(uuid);
    }

    // eslint-disable-next-line
  }, []);

  return null;
};

export default SurveyExternalSource;
